import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import {
  HeaderPage,
  TableExtraGroupsAdmin,
  AddEditExtraGroupForm,
} from "../../components/Admin";
import { ModalBasic, ModalConfirm } from "../../components/Common";
import { useExtraGroup } from "../../hooks";

export function ExtrasAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const { loading, extraGroups, getExtraGroups, deleteExtraGroup } =
    useExtraGroup();

  useEffect(() => {
    getExtraGroups();
  }, [refetch]);

  const openCloseModal = () => setShowModal((prev) => !prev);
  const onRefetch = () => setRefetch((prev) => !prev);

  const addExtraGroup = () => {
    setTitleModal("Nuevo grupo de adicionales");
    setContentModal(
      <AddEditExtraGroupForm onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updateExtraGroup = (data) => {
    setTitleModal("Editar grupo de adicionales");
    setContentModal(
      <AddEditExtraGroupForm
        onClose={openCloseModal}
        onRefetch={onRefetch}
        extraGroup={data}
      />
    );
    openCloseModal();
  };

  const onDeleteExtraGroup = (data) => setDeleteTarget(data);

  const confirmDeleteExtraGroup = async () => {
    await deleteExtraGroup(deleteTarget.id);
    setDeleteTarget(null);
    onRefetch();
  };

  return (
    <>
      <HeaderPage
        title="Adicionales"
        btnTitle="Nuevo grupo"
        btnClick={addExtraGroup}
      />

      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <TableExtraGroupsAdmin
          extraGroups={extraGroups}
          updateExtraGroup={updateExtraGroup}
          deleteExtraGroup={onDeleteExtraGroup}
        />
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

      <ModalConfirm
        title="¿Eliminar grupo de adicionales?"
        content={`Se eliminará "${deleteTarget?.label}" de forma permanente.`}
        show={!!deleteTarget}
        onCloseText="Cancelar"
        onClose={() => setDeleteTarget(null)}
        onConfirmText="Eliminar"
        onConfirm={confirmDeleteExtraGroup}
      />
    </>
  );
}
